import { EntityRepository, Repository } from "typeorm";
import { TransferInfo } from "../entities/transfer-material.entity";

@EntityRepository(TransferInfo)
export class TransferRepository extends Repository<TransferInfo>{

}